<template>
  <div id="app">
    <div
      v-if="showSignIn === null"
      class="ui active dimmer">
      <div class="ui loader"/>
    </div>

    <div class="ui padded grid" v-if="showSignIn !== null">
      <div class="sixteen wide column">
        <div
          v-if="showSignIn === false"
          class="ui red button"
          @click="authenticate">Log In with Healint Email
        </div>

        <div v-if="showSignIn === true">

          <div class="ui left labeled fluid icon input">
            <div class="ui label">
              <i class="book icon"></i> Search Data Definitions
            </div>
            <input type="text" placeholder="You can search by all columns" v-model="searchTerms">
            <i class="search icon"></i>
          </div>

          <table class="ui definition table">
            <thead v-if="$route.path === '/'">
              <tr><th></th>
                <th>Notes</th>
                <th>Source</th>
                <th>Type</th>
              </tr>
            </thead>

            <thead v-if="$route.path === '/data'">
              <tr><th></th>
                <th>Primary Table</th>
                <th>Lookup</th>
                <th>Source</th>
                <th>Type</th>
                <th>Notes</th>
              </tr>
            </thead>

            <tbody v-if="$route.path === '/'">
              <data-dictionary-card
                v-for="(item, index) in searchResultsDataDictionary"
                :entry="item">
              </data-dictionary-card>
            </tbody>

            <tbody v-if="$route.path === '/data'">
              <data-scientist-card
                v-for="(item, index) in searchResultsDataDictionary"
                :entry="item">
              </data-scientist-card>
            </tbody>


          </table>

        </div>

      </div>
    </div>


  </div>
</template>

<script>
import DataDictionaryCard from './components/DataDictionaryCard'
import DataScientistCard from './components/DataScientistCard'

export default {
  name: 'App',
  components: {
    DataDictionaryCard,
    DataScientistCard
  },
  data () {
    return {
      showSignIn: null,
      dataDictionaryRawResponse: null,
      searchTerms: ''
    }
  },
  computed: {
    searchResultsDataDictionary () {
      if (this.searchTerms === '') {
        return this.dataDictionaryRawResponse
      } else {
        let k = [];
        let temp;

        if (this.$route.name === '/data') {
          for (let i = 0; i < this.dataDictionaryRawResponse.length; i++ ) {
            temp = this.dataDictionaryRawResponse[i].filter(item => item.toString().toLowerCase().includes(this.searchTerms.toLowerCase()));
            if (temp.length > 0) {
              k.push(this.dataDictionaryRawResponse[i]);
            }
          }
        } else {
          for (let i = 0; i < this.dataDictionaryRawResponse.length; i++ ) {
            if (this.dataDictionaryRawResponse[i].length > 0) {
              let currentItem = this.dataDictionaryRawResponse[i];
              let lookupString = currentItem[0].concat(currentItem[5], currentItem[3], currentItem[4])
              temp = lookupString.toLowerCase().includes(this.searchTerms.toLowerCase());
              if (temp === true) {
                k.push(this.dataDictionaryRawResponse[i]);
              }
            }

          }
        }

        return k;
      }
    }
  },
  created () {

    gapi.load('client:auth2', () => {
      gapi.auth2.init({client_id: '950861727932-40n9n475gtksfauou43nn92rcob88mjl.apps.googleusercontent.com'}).then(()=> {
        this.loadClient();
      })
    })

  },
  methods: {
    authenticate () {
      return gapi.auth2.getAuthInstance()
        .signIn({scope: 'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/spreadsheets.readonly'})
        .then(() => {
          this.loadClient();
        }, (err) => {
          console.error('Error signing in', err)
        })
    },
    loadClient () {
      return gapi.client.load('https://content.googleapis.com/discovery/v1/apis/sheets/v4/rest')
        .then(() => {
          this.showSignIn = true;
          this.execute();
        }, (err) => {
          this.showSignIn = false;
          console.error('Error loading GAPI client for API', err)
        })
    },

    // Make sure the client is loaded and sign-in is complete before calling this method.
    execute () {
      if (typeof (gapi.client.sheets) === 'undefined') {
        this.authenticate().then(this.loadClient());
      } else {
        return gapi.client.sheets.spreadsheets.values.batchGet({
          'spreadsheetId': '166ZMLQdLhM-lT6dvK1SeWD0us6iItjsQawy9OJyNLSo', 'dateTimeRenderOption': 'FORMATTED_STRING', 'majorDimension': 'ROWS', 'ranges': ['A:F'], 'valueRenderOption': 'FORMATTED_VALUE'
        })
          .then((response) => {
            // Handle the results here (response.result has the parsed body).
            this.dataDictionaryRawResponse = response.result.valueRanges[0].values.splice(1, response.result.valueRanges[0].values.length);
          }, (err) => {
            this.showSignIn = false;
            console.error('Execute error', err)
          })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue